<template>

  <div id="academy_prd">

    <div class="c-img-bg c-academy-bg">

      <div class="container-xl">
        <div class="row">
          <div class="col-12">

            <!-- navigation-->
            <Navi dark-mode></Navi>

            <!-- happiness & work - products -->  
            <div class="row justify-content-center">
              <div class="col-11 coll-md-10">
                <div class="row align-items-end">
                  <div class="col-12 order-1 col-md-12 order-md-1 py-3 align-self-start">             
                    <p class="c-txt-orange" style="font-weight: bold;">Material zum Erwerben</p>
                    <h2 class="text-center text-md-center c-h2" >Produkte & Materialien</h2>
                  </div>
                  <div class="col-12 order-2 col-md-6 order-md-2 align-self-center">
                    <img id="bubble_hho" src="@/assets/academy_tools.png" alt="HappinessAndWork_Tools">
                  </div>
                  <div class="col-12 order-3 col-md-6 order-md-3 py-3 align-self-start"> 
                    <p class="text-center text-md-left">
                        Hier bieten einige Produkte zum kaufen an, die wir in unseren Trainings und Workshops einsetzen. 
                        Sie können diese Materialien für Ihre eigenen Trainings, Workshops und Teamentwicklungen einsetzen.
                    </p>
                    <!-- contact -->
                    <div class="d-flex justify-content-left">  
                      <!-- button -->
                      <a :href="`mailto:info@happinessandwork.de?subject=${emailSubject}&body=${emailBody}`">
                        <div class="c-btn c-btn-orange" >
                          <span style="padding: 10px">Schreib uns</span>
                          <div class="c-btn-img c-btn-img-right-white"/>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div class="col-12 order-3 col-md-12 py-4 align-self-start"> 
                    <!-- Products -->
                    <p class="text-left">
                      <br/><br/><br/>
                      Folgende Produkte können Sie in unserem Shop bei Digistore24 erwerben. 
                    </p>     
                    <div class="row py-3" v-for="(product, index) in products" :key="product.id || index">
                      <div class="col-12 col-md-2">
                        <p class="text-left c-txt-orange" style="font-weight: bold;">{{ product.name }}</p>
                        <p class="text-left">[{{ product.product_type_name }}]</p>
                      </div>
                      <div class="col-12 col-md-3">
                        <img :src="product.image_url" :alt="product.name" style="max-width: 150px; max-height: 200px;"/>
                      </div>
                      <div class="col-12 col-md-5" v-html="product.description"></div>
                      <!-- <div class="col-6 col-md-1">Preis: {{ product.price }} {{ product.currency }}</div> -->
                      <!-- <div class="col-12 col-md-2"><a :href="orderform_customer_url || '#'" target="_blank" rel="noopener noreferrer">Kaufen</a></div> -->
                      <div class="col-12 col-md-2 d-flex">  
                        <!-- button -->
                        <a :href="product.orderform_customer_url || '#'" target="_blank" rel="noopener noreferrer">
                          <div class="c-btn c-btn-orange" ><span style="padding: 10px">Kaufen</span><div class="c-btn-img c-btn-img-right-white"/></div>
                        </a>
                      </div>
                    </div>
                    <p v-if="productsLoadError" class="text-left c-txt-orange" style="font-weight: bold;">
                      {{ productsLoadError }}
                    </p>
                  </div>                
                </div> 
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- wave bottom -->
      <div class="c-wave c-wave-bottom"/>
    </div>

    <!-- footer -->
    <div class="c-orange-bg">   
      <!-- wave top -->
      <div class="c-wave c-wave-top" style="position: relative; top:-2px;"/>
      <!-- footer content -->
      <div class="container-xl">
        <div class="row c-txt-white c-footer">
          <div class="col-12">
            <Footer></Footer>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Navi from '@/components/Navi.vue'
import Footer from '@/components/Footer.vue'

import Digistore24ClientService from '@/services/Digistore24ClientService';

export default {
  name: 'Academy_KAT',
  components: {
    Navi,
    Footer
  },
  metaInfo() {
    // patch meta data on current page
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: `${this.metaTitle}`,
      meta: [
        { vmid: "keywords",  name: 'keywords', content: `${this.metaKeywords}` },
        { vmid: "description", name: 'description', content: `${this.metaDescription}`},
        // social tagging
        { vmid: "og:title", property: "og:title", content: `${this.metaTitle}` },
        { vmid: "og:url", property: "og:url", content: `${this.metaUrl}` },
        { vmid: "og:description", property: "og:description", content: `${this.metaDescription}` },
        { vmid: "og:image", name: 'og:image', content: `${this.metaImage}` }
      ]
    }
  },
  data() {
    return {
      // email data
      emailSubject: "HAW Anfrage - Academy - Produkte",
      emailBody: "Guten Tag,%0A%0Aich bin auf der Website www.happinessandwork.de auf euer Angebot aufmerksam geworden.%0AIch interessiere mich insbesondere für 'Academy - Produkte'.%0AIch würde gern diesbezüglich kontaktiert werden - Tel: [meine_telefonnummer]%0A%0AVielen Dank",
      // metaData
      metaTitle: "- Academy - Wie schafft es eine Organisation, dass ihre Mitarbeiter glücklich sind?",
      metaDescription: "Wie schafft es eine Organisation, dass ihre Mitarbeiter glücklich sind? Die Felicicon GmbH hat Weiterbildungsangebote für Mitarbeiter und Führungskräfte und führen in Mitarbeiter Events in das Thema ein.",
      metaUrl: "/academy/happiness_and_homeoffice",
      metaKeywords: "Seminar Beratung Coaching Teamentwicklung Keynotes Homeoffice 'Happinessandwork Academy'",
      metaImage: "https://www.happinessandwork.de/share/academy.png",

      // product data
      products: [],
      productsLoadError: '',
      res: null
    }
  },
  // called when component is mounted to the dom
  mounted: async function () {
    // load products from Digistore24
    // get product list
    const digistore24ClientService = new Digistore24ClientService();
    try {
      const res = await digistore24ClientService.getProducts();
      this.productsLoadError = '';
      if (res && Array.isArray(res.data.products)) {
        this.products = res.data.products;
      } else {
        this.products = [];
        this.productsLoadError = 'Produktdaten konnten nicht verarbeitet werden.';
      }
    } catch (error) {
      this.products = [];
      this.productsLoadError = `Produkte konnten nicht geladen werden: ${error.message || 'Unbekannter Fehler'}`;
    }

    // details about each product
    this.products.forEach((product) => {
      const res = digistore24ClientService.getProduct(product.id);
      this.res = res;
      // do nothing just chack in debugger
    });
  },
  methods: {
  }
}

</script>

<style>

</style>
